import { BiButton, BiButtonGroup, BiTypography } from 'bi-web-components-react';
import { useEffect, useState } from 'react';
import styles from './chooseYourPath.module.css';
import { ComponentSelector } from '../../types';
import { Pending } from '@bino/utils/components/pending';
import { trackGAEvent } from '@bino/utils/functions';
import { useTranslation } from 'react-i18next';

export type ChooseYourPathProps = {
    setComponent: (val: ComponentSelector) => void;
    portalURL: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let embeddedservice_bootstrap: any;

type ChatParams = {
    firstName: string;
    lastName: string;
    email: string;
    contactId: string | null;
    category: string;
    contactUsOpen: string | null;
} | null;

export default function ChooseYourPath({ setComponent, portalURL }: ChooseYourPathProps) {
    const { t } = useTranslation('chat');
    const [waitingChat, setWaitingChat] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    const firstName = searchParams.get('firstName');
    const lastName = searchParams.get('lastName');
    const email = searchParams.get('email');
    const contactUsOpen = searchParams.get('contactusopen');
    const contactId = searchParams.get('contactid');
    const chatParams: ChatParams =
        firstName && lastName && email
            ? { firstName, lastName, email, contactId, category: 'Admission', contactUsOpen }
            : null;

    useEffect(() => {
        if (chatParams?.contactUsOpen) {
            openChat();
        }
    }, [chatParams?.contactUsOpen]);

    const openChat = () => {
        setWaitingChat(true);
        try {
            embeddedservice_bootstrap.utilAPI.launchChat().then(() => {
                setWaitingChat(false);
            });
        } catch (e) {
            setWaitingChat(false);
            console.error('Error in chatHandler', e);
        }
    };

    function goToUrl() {
        window.location.href = portalURL;
        trackGAEvent({
            event: 'Chat',
            data: {
                action: 'Chat with us - log in',
                label: 'Login',
            },
        });
    }

    function navigateToFront() {
        setComponent('front');
    }

    if (chatParams?.contactUsOpen) {
        return <Pending />;
    }

    return (
        <div className={styles.chooseYourPath}>
            <div className={styles.mainText}>
                <BiTypography fontStyle='bold' fontSize='large'>
                    <p>{t('areYouStudent')}</p>
                </BiTypography>
                <BiTypography>
                    <p className={styles.chooseYourPathText}>{t('studentDesc')}</p>
                </BiTypography>
            </div>
            <div className={styles.chooseYourPathButtonContainer}>
                <BiButtonGroup direction='vertical' alignment='center'>
                    <BiButton stretch onClick={goToUrl}>
                        {t('logIn')}
                    </BiButton>
                    <BiButton stretch onClick={openChat} submitting={waitingChat} disabled={waitingChat}>
                        Start chat
                    </BiButton>
                    <BiButton variant='text' onClick={navigateToFront}>
                        {t('cancel')}
                    </BiButton>
                </BiButtonGroup>
            </div>
        </div>
    );
}
